import assign from 'lodash.assign';
export class DocumentReference {
    constructor(init) {
        assign(this, init);
    }
    id;
    copyIndicator;
    uuid;
    issueDate;
    issueTime;
    documentTypeCode;
    documentType;
    xPath;
    languageID;
    localeCode;
    versionID;
    documentStatusCode;
    documentDescription;
    attachment;
    validityPeriod;
    issuerParty;
    resultOfVerification;
}
